const { coreApi } = require('../utils/axios');

async function getCategories() {
  const response = await coreApi.get('/services/category');
  return response.data.data;
}

async function getNationalMasterServices(pharmacyId) {
  const response = await coreApi.get('/services/catalog/national?pharmacy_id=' + pharmacyId);
  return response.data.data;
}

async function postPharmaciesToMasterService(actions) {
  const response = await coreApi.post('/services/catalog/pharmacies', { actions });
  return response.data.data;
}

async function getServiceCategory(categoryId) {
  const response = await coreApi.get(`/services/category/${categoryId}`);
  return response.data.data[0];
}

async function updateCategoriesOrder(newOrder) {
  const response = await coreApi.put('/services/category/order', { order: newOrder });
  return response.data.data;
}

async function deleteCategory(categoryId) {
  const response = await coreApi.delete(`/services/category/${categoryId}`);
  return response.data;
}

async function getServiceCatalog({ pharmacyStats, fields, page, limit, type }) {
  const queryParams = new URLSearchParams();
  if (type) queryParams.set('type', type);
  if (pharmacyStats !== undefined) queryParams.set('pharmacy_stats', pharmacyStats);
  if (fields !== undefined) fields.forEach(field => queryParams.append('fields[]', field));
  if (page !== undefined) queryParams.set('page', page);
  if (limit !== undefined) queryParams.set('limit', limit);
  const queryString = queryParams.toString();
  
  const response = await coreApi.get(`/services/catalog${queryString ? `?${queryString}` : ''}`);
  return response.data;
}

async function searchServiceCatalog(searchTerm) {
  const response = await coreApi.get(`/services/catalog/search?service_name=${searchTerm}`);
  return response.data.data;
}

async function createServiceCategory(category) {
  const response = await coreApi.post(`/services/category`, category);
  return response.data.data[0];
}

async function updateServiceCategory({ _id, ...payload }) {
  const response = await coreApi.put(`/services/category/${_id}`, payload);
  return response.data.data[0];
}

function upsertServiceCategory(category) {
  if (category._id) return updateServiceCategory(category);
  return createServiceCategory(category);
}

async function getServicesAvatars() {
  const response = await coreApi.get('/avatars?type=service');
  return response.data.data;
}

async function getServiceById(serviceId) {
  const response = await coreApi.get(`/services/catalog/${serviceId}`);
  return response.data.data[0];
}

async function createMasterService(updatePayload, formData) {
  const response = await coreApi.post(
    '/services/catalog',
    formData || updatePayload,
    { headers: { 'Content-Type': formData ? 'multipart/form-data' : 'application/json' } }
  );
  return response.data.data[0];
}

async function updateMasterService(_id, updatePayload, formData) {
  const response = await coreApi.put(
    `/services/catalog/${_id}`,
    formData || updatePayload,
    { headers: { 'Content-Type': formData ? 'multipart/form-data' : 'application/json' } }
  );
  return response.data.data[0];
}

function upsertMasterService({ _id, updatePayload, formData }) {
  if (_id) return updateMasterService(_id, updatePayload, formData);
  return createMasterService(updatePayload, formData);
}

//#region Service conditions
async function getServiceConditions(query = {}) {
  const queryParams = new URLSearchParams();
  Object.keys(query).forEach((key) => {
    if (Array.isArray(query[key])) {
      query[key].forEach(value => queryParams.append(key, value));
      return;
    }

    queryParams.set(key, query[key]);
  });
  const queryString = queryParams.toString();
  const response = await coreApi.get(`/services/condition${queryString ? `?${queryString}` : ''}`);

  return response.data;
}

async function getServiceCondition(conditionId) {
  const response = await coreApi.get(`/services/condition/${conditionId}`);
  return response.data.data[0];
}

async function createServiceCondition(updatePayload, formData) {
  const response = await coreApi.post(
    '/services/condition',
    formData || updatePayload,
    { headers: { 'Content-Type': formData ? 'multipart/form-data' : 'application/json' } }
  );
  return response.data.data[0];
}

async function updateServiceCondition(_id, updatePayload, formData) {
  const response = await coreApi.put(
    `/services/condition/${_id}`,
    formData || updatePayload,
    { headers: { 'Content-Type': formData ? 'multipart/form-data' : 'application/json' } }
  );
  return response.data.data[0];
}

function upsertServiceCondition({ _id, updatePayload, formData }) {
  if (_id) return updateServiceCondition(_id, updatePayload, formData);
  return createServiceCondition(updatePayload, formData);
}

async function deleteServiceCondition(conditionId) {
  const response = await coreApi.delete(`/services/condition/${conditionId}`);
  return response.data.data[0];
}

async function deleteMasterService(serviceId) {
  const response = await coreApi.delete(`/services/catalog/${serviceId}`);
  return response.data.data[0];
}
//#endregion

const masterServicesAPI = {
  getCategories,
  getServiceCategory,
  updateCategoriesOrder,
  deleteCategory,
  getServiceCatalog,
  searchServiceCatalog,
  upsertServiceCategory,
  getServicesAvatars,
  getServiceById,
  deleteMasterService,
  upsertMasterService,
  getServiceConditions,
  getServiceCondition,
  upsertServiceCondition,
  deleteServiceCondition,
  getNationalMasterServices,
  postPharmaciesToMasterService,
};

export default masterServicesAPI;
